export default "__VITE_ASSET__CRDShJ6G__"